import { render, staticRenderFns } from "./paysinglewitholding.vue?vue&type=template&id=2dd21ea5"
import script from "./paysinglewitholding.vue?vue&type=script&lang=js"
export * from "./paysinglewitholding.vue?vue&type=script&lang=js"
import style0 from "./paysinglewitholding.vue?vue&type=style&index=0&id=2dd21ea5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports